import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredFacebook = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M14 7C14 3.134 10.866 0 7 0C3.134 0 0 3.134 0 7C0 10.4939 2.55979 13.3898 5.90625 13.915V9.02343H4.12891V7H5.90625V5.45781C5.90625 3.70343 6.95129 2.73438 8.55025 2.73438C9.31611 2.73438 10.1172 2.87109 10.1172 2.87109V4.59375H9.2345C8.36493 4.59375 8.09375 5.13334 8.09375 5.68692V7H10.0352L9.7248 9.02343H8.09374V13.915C11.4402 13.3898 14 10.4939 14 7Z"
      fill="#1877F2"
    />
    <path
      d="M9.72468 9.02343L10.035 7H8.09362V5.6869C8.09362 5.13334 8.3648 4.59375 9.23438 4.59375H10.1171V2.87109C10.1171 2.87109 9.31599 2.73438 8.55012 2.73438C6.95117 2.73438 5.90612 3.70343 5.90612 5.45781V7H4.12878V9.02343H5.90612V13.915C6.26795 13.9717 6.63364 14.0001 6.99988 14C7.37197 14 7.73723 13.9709 8.09362 13.915V9.02343H9.72468Z"
      fill="white"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColouredFacebook)
const IconSvgColouredFacebook = createIcon(ForwardRef, 'SvgColouredFacebook')
export default IconSvgColouredFacebook
